import { create } from 'zustand';

interface ScribeWindowState {
  appointmentId: string | null;
  openScribeWindow: (appointmentId: string) => void;
  closeScribeWindow: () => void;
}

// Not persisted: a reload ends any recording, so reopening the window on load would show a
// session that no longer exists.
export const useScribeWindow = create<ScribeWindowState>()((set) => ({
  appointmentId: null,
  // An open window keeps its appointment: its recording belongs to that appointment's recap.
  openScribeWindow: (appointmentId: string) =>
    set((state) => ({ appointmentId: state.appointmentId ?? appointmentId })),
  closeScribeWindow: () => set({ appointmentId: null }),
}));
